module.exports = __webpack_public_path__ + "img/horizontal_4_3_pp3_8004.d4f9f4da.png";